module.exports = __webpack_public_path__ + "img/download-googleplay.898370ee.svg";